import React from 'react';
import { ArrowRight, Check, Gift, Lock, Shield, Zap } from 'lucide-react';
import { Button } from './Button';
import { offerBonuses, offerExtras, offerVolumes } from '../data/offer';
const groups = [{
  title: 'You receive:',
  items: offerVolumes,
  icon: Check
}, {
  title: 'Plus:',
  items: offerBonuses,
  icon: Gift
}, {
  title: 'Plus:',
  items: offerExtras,
  icon: Check
}];
export function PricingSection() {
  return <section id="offer" className="py-24 px-4 bg-forest scroll-mt-4" data-id="element-235" data-mp="1n9r1xwiwttll">
      <div className="max-w-5xl mx-auto" data-id="element-236" data-mp="1s93zbb7eqj2f">
        <div className="text-center mb-12" data-id="element-237" data-mp="1s82ck9h1484v">
          <p className="text-seafoam font-bold mb-3" data-id="element-238" data-mp="1x8zt6hme4u49">Your complete offer today</p>
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-3 text-white" data-id="element-239" data-mp="1x6vs07fvm97o">
            MOUNTAIN BIKE COACH READY
          </h2>
          <p className="text-white/85 text-base md:text-lg" data-id="element-240" data-mp="2vqrvd400ex3">
            The Complete 6-in-1 MTB Coaching System
          </p>
        </div>

        <div className="grid lg:grid-cols-[7fr_5fr] gap-6 mb-12" data-id="element-241" data-mp="7vwbq7410x4m">
          <div className="bg-white rounded-2xl p-6 md:p-8" data-id="element-242" data-mp="1mhgbcp33pdc7">
            <h3 className="text-sm font-sans font-bold text-navy mb-4" data-id="element-243" data-mp="1hq81jrxuzpyi">{groups[0].title}</h3>
            <ul className="space-y-3" data-id="element-244" data-mp="1cqv4yfh6r4iq">
              {groups[0].items.map(item => <li key={item} className="flex items-start gap-3 text-base text-ink" data-id="element-245" data-mp="1coiltyzoyo43">
                  <Check size={18} strokeWidth={3} className="text-seafoam-dark shrink-0 mt-0.5" aria-hidden="true" data-id="element-246" data-mp="17ppaod7vn973" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="grid gap-6" data-id="element-247" data-mp="20emtchg0380d">
            {groups.slice(1).map(group => <div key={group.items[0]} className="bg-white rounded-2xl p-6" data-id="element-248" data-mp="1vjfr7e2dqbdk">
                <h3 className="text-sm font-sans font-bold text-navy mb-3" data-id="element-249" data-mp="1rf80jbcd2lcp">{group.title}</h3>
                <ul className="space-y-2" data-id="element-250" data-mp="k2zcjmynfyrr">
                  {group.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-ink" data-id="element-251" data-mp="fzt6afbje7la">
                      <group.icon size={16} className={`${group.icon === Gift ? 'text-orange' : 'text-seafoam-dark'} shrink-0 mt-0.5`} aria-hidden="true" data-id="element-252" data-mp="hit7td27o4a5" />
                      {item}
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-253" data-mp="3uvw7wqx92x74">
          <p className="text-white/80 text-lg mb-1" data-id="element-254" data-mp="3uuti6mbnz0ss">TODAY:</p>
          <p className="font-display font-black text-orange-light text-5xl md:text-7xl mb-8" data-id="element-255" data-mp="3is3toqnggqg">
            USD $27.00
          </p>
          <Button className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-6" data-id="element-256" data-mp="3kwdsmnsabzle">
            GET THE COMPLETE 6-IN-1 MTB COACHING SYSTEM NOW
            <ArrowRight size={20} aria-hidden="true" className="shrink-0" data-id="element-257" data-mp="3bxjx70qoxf9f" />
          </Button>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-white/85" data-id="element-258" data-mp="3fzx1rltpb74m">
            <span className="flex items-center gap-1.5" data-id="element-259" data-mp="2xala1hyv970i">
              <Lock size={14} className="text-seafoam" aria-hidden="true" data-id="element-260" data-mp="2xd7h7ghuhki7" /> Secure Payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-261" data-mp="2sed0ql7co819">
              <Zap size={14} className="text-seafoam" aria-hidden="true" data-id="element-262" data-mp="36cks8dlmah51" /> Immediate Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-263" data-mp="31b56skfj28m4">
              <Shield size={14} className="text-seafoam" aria-hidden="true" data-id="element-264" data-mp="3g9fn8miolzek" /> 7-Day Guarantee
            </span>
          </div>
        </div>
      </div>
    </section>;
}